/* ORELLA — personalized jewelry storytelling layer */
(function () {
  'use strict';
  var FIN = ['Gold', 'Rose Gold', 'Silver'];
  var FINMAP = { 'Or': 'Gold', 'Or rose': 'Rose Gold', 'Argent': 'Silver', 'Argent 925': 'Silver', 'S925 Silver': 'Silver' };
  function normFin(v) { return FINMAP[v] || v; }
  var HEART_D = 'M100 182 C 52 142 8 108 14 58 C 20 16 76 6 100 48 C 124 6 180 16 186 58 C 192 108 148 142 100 182';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function $$self(s, r) { return (r && r.matches && r.matches(s) ? [r] : []).concat($$(s, r)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = $$self('[data-oss-reveal]', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- hero: names written one after another ---------- */
  function initHero(root) {
    $$('[data-oss-names]', root).forEach(function (box) {
      var names = (box.getAttribute('data-oss-names') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!names.length) return;
      box.innerHTML = names.map(function (n) { return '<span>' + esc(n) + '</span>'; }).join('');
      var spans = $$('span', box), cur = -1;
      function show() {
        var next = (cur + 1) % spans.length;
        if (cur > -1 && spans.length > 1) {
          var p = spans[cur];
          p.classList.remove('is-on'); p.classList.add('is-off');
          setTimeout(function () { p.classList.remove('is-off'); }, 950);
        }
        setTimeout(function () { spans[next].classList.add('is-on'); }, cur > -1 ? 500 : 200);
        cur = next;
      }
      show();
      if (spans.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(show, 3200);
    });
  }

  /* ---------- story band: lines light up while scrolling ---------- */
  function initBand(root) {
    $$('[data-oss-band]', root).forEach(function (band) {
      var lines = $$('span', band);
      function tick() {
        var vh = window.innerHeight;
        lines.forEach(function (l) {
          var r = l.getBoundingClientRect();
          l.classList.toggle('is-lit', r.top < vh * 0.72 && r.bottom > vh * 0.18);
        });
      }
      window.addEventListener('scroll', tick, { passive: true });
      tick();
    });
  }

  /* ---------- shared: heart pendant SVG with name beads ---------- */
  function heartSVG(names, uid) {
    var g = 'og' + uid;
    return '<svg class="orl-heart" viewBox="0 0 200 200" aria-hidden="true">' +
      '<defs><linearGradient id="' + g + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="var(--m1)"/><stop offset=".35" stop-color="var(--m2)"/><stop offset=".6" stop-color="var(--m3)"/><stop offset="1" stop-color="var(--m4)"/></linearGradient></defs>' +
      '<path class="oss-heart-path" d="' + HEART_D + '" fill="none" stroke="url(#' + g + ')" stroke-width="9" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<g class="oss-beads" data-grad="' + g + '"></g></svg>';
  }
  function placeBeads(svg, names) {
    if (!svg) return;
    var path = svg.querySelector('.oss-heart-path'), g = svg.querySelector('.oss-beads');
    if (!path || !g) return;
    var len; try { len = path.getTotalLength(); } catch (e) { return; }
    if (!len) return;
    var grad = g.getAttribute('data-grad'), out = '';
    var n = names.length, step = 0.064, start = 0.06;
    names.forEach(function (nm, i) {
      var f = start + (n - 1 - i) * step, p = path.getPointAtLength(len * f), q = path.getPointAtLength(len * (f + 0.004));
      var a = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI;
      if (a > 90) a -= 180; else if (a < -90) a += 180;
      var label = (nm || '').toUpperCase().slice(0, 10) || '·';
      var tl = label.length > 6 ? ' textLength="36" lengthAdjust="spacingAndGlyphs"' : '';
      out += '<g class="bead" transform="translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ') rotate(' + a.toFixed(1) + ')">' +
        '<rect x="-22" y="-10" width="44" height="20" rx="5" fill="url(#' + grad + ')" stroke="rgba(0,0,0,.12)" stroke-width=".6"/>' +
        '<text x="0" y="3.3" text-anchor="middle" fill="rgba(40,26,18,.78)"' + tl + '>' + esc(label) + '</text></g>';
    });
    g.innerHTML = out;
  }
  function fitText(el, box, max) {
    if (!el || !box) return;
    el.style.fontSize = '';
    var cs = parseFloat(getComputedStyle(el).fontSize) || max, w = box.clientWidth - 40, guard = 0;
    while (el.scrollWidth > w && cs > 26 && guard++ < 60) { cs -= 3; el.style.fontSize = cs + 'px'; }
  }
  function chainPath(svg, el, holder) {
    if (!svg || !el || !holder) return;
    var hb = holder.getBoundingClientRect(), r = el.getBoundingClientRect();
    if (!hb.width) return;
    var y = r.top - hb.top + r.height * 0.42, x1 = r.left - hb.left + 6, x2 = r.right - hb.left - 6, W = hb.width;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + hb.height);
    svg.innerHTML = '<path d="M -10 ' + (y - hb.height * 0.55) + ' Q ' + (x1 * 0.45) + ' ' + (y - 6) + ' ' + x1 + ' ' + y + '"/>' +
      '<path d="M ' + x2 + ' ' + y + ' Q ' + (x2 + (W - x2) * 0.55) + ' ' + (y - 6) + ' ' + (W + 10) + ' ' + (y - hb.height * 0.55) + '"/>';
  }

  /* ---------- extra pendant drawings ---------- */
  function grad(id) {
    return '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="var(--m1)"/><stop offset=".35" stop-color="var(--m2)"/><stop offset=".6" stop-color="var(--m3)"/><stop offset="1" stop-color="var(--m4)"/></linearGradient></defs>';
  }
  function puzzleSVG(a, b, uid) {
    var g = 'pz' + uid, L = 'pl' + uid, R = 'pr' + uid;
    var heart = 'M100 186 C 50 146 6 112 12 60 C 18 16 76 4 100 48 C 124 4 182 16 188 60 C 194 112 150 146 100 186 Z';
    var t = function (txt, x, y, r) { return '<text x="' + x + '" y="' + y + '" transform="rotate(' + r + ' ' + x + ' ' + y + ')" text-anchor="middle" font-family="Cormorant Garamond, Georgia, serif" font-size="15" letter-spacing="1.2" fill="rgba(40,26,18,.78)">' + esc(txt) + '</text>'; };
    return '<svg viewBox="0 0 200 200" aria-hidden="true">' + grad(g) +
      '<defs><clipPath id="' + L + '"><path d="M0 0 H100 V72 C 76 64 72 104 100 98 V200 H0 Z"/></clipPath><clipPath id="' + R + '"><path d="M200 0 H100 V72 C 76 64 72 104 100 98 V200 H200 Z"/></clipPath></defs>' +
      '<g transform="translate(-3 0)"><path d="' + heart + '" fill="url(#' + g + ')" clip-path="url(#' + L + ')"/>' + t(a || 'SARAH', 50, 104, -8) + '</g>' +
      '<g transform="translate(5 2) rotate(2 150 100)"><path d="' + heart + '" fill="url(#' + g + ')" clip-path="url(#' + R + ')"/>' + t(b || 'TOM', 150, 104, 8) + '</g>' +
      '<circle cx="100" cy="30" r="6" fill="none" stroke="url(#' + g + ')" stroke-width="2.4"/></svg>';
  }
  function roman(n) {
    var m = [[1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'], [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'], [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']], o = '';
    n = parseInt(n, 10) || 0; m.forEach(function (p) { while (n >= p[0]) { o += p[1]; n -= p[0]; } }); return o;
  }
  function dateText(v, fmt) {
    var p = (v || '2019-02-14').split('-'); if (p.length < 3) p = ['2019', '02', '14'];
    return fmt === 'roman' ? roman(p[2]) + ' · ' + roman(p[1]) + ' · ' + roman(p[0]) : p[2] + ' · ' + p[1] + ' · ' + p[0];
  }
  function dateSVG(txt, uid) {
    var g = 'dt' + uid, fs = txt.length > 16 ? 15 : 19;
    return '<svg viewBox="0 0 340 90" aria-hidden="true">' + grad(g) +
      '<rect x="10" y="24" width="320" height="44" rx="22" fill="url(#' + g + ')"/>' +
      '<rect x="16" y="29" width="308" height="34" rx="17" fill="none" stroke="rgba(255,255,255,.45)" stroke-width=".8"/>' +
      '<text x="170" y="52" text-anchor="middle" font-family="Cormorant Garamond, Georgia, serif" font-size="' + fs + '" letter-spacing="2.5" fill="rgba(40,26,18,.8)">' + esc(txt) + '</text></svg>';
  }
  function initialsSVG(a, b, uid) {
    var g = 'in' + uid;
    return '<svg viewBox="0 0 200 210" aria-hidden="true">' + grad(g) +
      '<circle cx="100" cy="24" r="9" fill="none" stroke="url(#' + g + ')" stroke-width="3"/>' +
      '<circle cx="100" cy="116" r="82" fill="url(#' + g + ')"/>' +
      '<circle cx="100" cy="116" r="72" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="1"/>' +
      '<text x="100" y="138" text-anchor="middle" font-family="Cormorant Garamond, Georgia, serif" font-style="italic" font-size="58" fill="rgba(40,26,18,.78)">' + esc((a || 'A').toUpperCase()) + '<tspan font-size="30" dx="6" dy="-8" fill="rgba(140,60,50,.75)">♥</tspan><tspan dx="6" dy="8">' + esc((b || 'J').toUpperCase()) + '</tspan></text></svg>';
  }

  /* ---------- homepage writer / atelier ---------- */
  function initWriter(root) {
    $$self('[data-oss-writer]', root).forEach(function (w, wi) {
      var state = { piece: w.getAttribute('data-piece') || 'script', finish: 'Gold', fmt: 'num' };
      var nameIn = $('[data-oss-name]', w), beadIns = $$('[data-oss-bead]', w), puzIns = $$('[data-ox-puzzle]', w), iniIns = $$('[data-ox-ini]', w), dateIn = $('[data-ox-date]', w);
      var prevName = $('.oss-preview__name', w), heartBox = $('.oss-preview__heart', w), svgBox = $('.ox-preview__svg', w), stage = $('.oss-writer__stage', w), chain = $('.oss-writer__chain', w);
      var cta = $('[data-oss-cta]', w), ctaLabel = $('[data-ox-cta-label]', w), count = $('[data-oss-count]', w), price = $('[data-oss-price]', w);
      if (heartBox) heartBox.innerHTML = heartSVG([], 'w' + wi);
      function vals(list) { return list.map(function (i) { return i.value.trim(); }).filter(Boolean); }
      function query() {
        switch (state.piece) {
          case 'script': return 'name=' + encodeURIComponent(nameIn.value.trim());
          case 'heart': return 'names=' + encodeURIComponent(vals(beadIns).join('|'));
          case 'puzzle': return 'names=' + encodeURIComponent(vals(puzIns).join('|'));
          case 'date': return 'date=' + encodeURIComponent(dateIn ? dateIn.value : '');
          case 'initials': return 'initials=' + encodeURIComponent(vals(iniIns).join('|'));
        }
        return '';
      }
      function render() {
        w.setAttribute('data-piece', state.piece); w.setAttribute('data-finish', state.finish);
        $$('[data-oss-piece-only]', w).forEach(function (el) { el.hidden = el.getAttribute('data-oss-piece-only') !== state.piece; });
        if (nameIn) { prevName.textContent = nameIn.value.trim() || nameIn.getAttribute('placeholder') || 'Emma'; if (count) count.textContent = nameIn.value.length + '/18'; }
        var anchor = null;
        if (state.piece === 'script') { fitText(prevName, stage, 112); anchor = prevName; }
        else if (state.piece === 'heart') { var ns = vals(beadIns); placeBeads($('svg', heartBox), ns.length ? ns : ['ANNA', 'LEO']); }
        else if (svgBox) {
          if (state.piece === 'puzzle') { var pz = puzIns.map(function (i) { return i.value.trim().toUpperCase(); }); svgBox.innerHTML = puzzleSVG(pz[0], pz[1], wi); }
          if (state.piece === 'date') { svgBox.innerHTML = dateSVG(dateText(dateIn && dateIn.value, state.fmt), wi); anchor = svgBox.querySelector('rect'); }
          if (state.piece === 'initials') { var ii = iniIns.map(function (i) { return i.value.trim(); }); svgBox.innerHTML = initialsSVG(ii[0], ii[1], wi); anchor = svgBox.querySelector('circle'); }
        }
        if (chain) { if (anchor) requestAnimationFrame(function () { chainPath(chain, anchor, stage); }); else chain.innerHTML = ''; }
        var url = w.getAttribute('data-url-' + state.piece) || '';
        if (url) {
          cta.classList.remove('is-soon'); cta.removeAttribute('aria-disabled');
          cta.setAttribute('href', url + (url.indexOf('?') > -1 ? '&' : '?') + query() + '&finish=' + encodeURIComponent(state.finish));
          if (ctaLabel) ctaLabel.textContent = w.getAttribute('data-cta') || ctaLabel.textContent;
        } else {
          cta.classList.add('is-soon'); cta.setAttribute('aria-disabled', 'true'); cta.removeAttribute('href');
          if (ctaLabel) ctaLabel.textContent = w.getAttribute('data-soon') || 'Coming soon';
        }
        if (price) price.textContent = w.getAttribute('data-price-' + state.piece) || '';
      }
      $$('[data-oss-tab]', w).forEach(function (b) {
        b.addEventListener('click', function () { state.piece = b.getAttribute('data-oss-tab'); $$('[data-oss-tab]', w).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); render(); });
      });
      $$('[data-oss-finish]', w).forEach(function (b) {
        b.addEventListener('click', function () { state.finish = b.getAttribute('data-v'); $$('[data-oss-finish]', w).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); render(); });
      });
      $$('[data-ox-fmt]', w).forEach(function (b) {
        b.addEventListener('click', function () { state.fmt = b.getAttribute('data-ox-fmt'); $$('[data-ox-fmt]', w).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); render(); });
      });
      $$('[data-oss-chip]', w).forEach(function (b) { b.addEventListener('click', function () { nameIn.value = b.getAttribute('data-oss-chip'); render(); nameIn.focus(); }); });
      if (nameIn) nameIn.addEventListener('input', render);
      if (dateIn) { dateIn.addEventListener('input', render); dateIn.addEventListener('change', render); }
      beadIns.concat(puzIns, iniIns).forEach(function (i) { i.addEventListener('input', function () { i.value = i.value.toUpperCase(); render(); }); });
      cta.addEventListener('click', function (e) { if (cta.classList.contains('is-soon')) e.preventDefault(); });
      window.addEventListener('resize', render);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
      w.ossSet = function (piece, val) {
        state.piece = piece; val = val || '';
        $$('[data-oss-tab]', w).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-oss-tab') === piece ? 'true' : 'false'); });
        var parts = val.split('|');
        if (val) {
          if (piece === 'script' && nameIn) nameIn.value = val;
          if (piece === 'heart') beadIns.forEach(function (i, k) { i.value = (parts[k] || '').toUpperCase(); });
          if (piece === 'puzzle') puzIns.forEach(function (i, k) { i.value = (parts[k] || '').toUpperCase(); });
          if (piece === 'initials') iniIns.forEach(function (i, k) { i.value = (parts[k] || '').toUpperCase().slice(0, 1); });
          if (piece === 'date' && dateIn) dateIn.value = val;
        }
        render();
      };
      render();
    });
  }

  /* ---------- hero rotating words ---------- */
  function initRotator(root) {
    $$('[data-ox-words]', root).forEach(function (box) {
      var words = (box.getAttribute('data-ox-words') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var el = box.querySelector('.ox-rotator__w'); if (!el || words.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function () {
        el.classList.add('is-out');
        setTimeout(function () { i = (i + 1) % words.length; el.textContent = words[i]; el.classList.remove('is-out'); el.classList.add('is-in'); requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('is-in'); }); }); }, 520);
      }, 2800);
    });
  }
  /* ---------- tiles that open the atelier ---------- */
  function initTiles(root) {
    $$('[data-ox-piece]', root).forEach(function (t) {
      t.addEventListener('click', function (e) {
        var href = t.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var w = document.querySelector('[data-oss-writer]'); if (!w || !w.ossSet) return;
        e.preventDefault(); w.ossSet(t.getAttribute('data-ox-piece'), '');
        w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
  /* ---------- horizontal track arrows ---------- */
  function initTrack(root) {
    $$('[data-ox-track]', root).forEach(function (tr) {
      var sec = tr.closest('.oss'); if (!sec) return;
      var step = function () { var c = tr.querySelector('.ox-occ__card'); return c ? c.getBoundingClientRect().width + 18 : 320; };
      var p = $('[data-ox-prev]', sec), n = $('[data-ox-next]', sec);
      if (p) p.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- moments: fill the writer ---------- */
  function initMoments(root) {
    $$('[data-oss-moment]', root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        var w = document.querySelector('[data-oss-writer]');
        if (!w || !w.ossSet) return;
        e.preventDefault();
        w.ossSet(b.getAttribute('data-piece') || 'script', b.getAttribute('data-oss-moment'));
        w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }


  /* ---------- product page fields: counter, bead count, uppercase, required guard ---------- */
  function initPdpFields() {
    $$('[data-orl-name],[data-orl-engrave]').forEach(function (root) {
      if (root.__orl) return; root.__orl = true;
      var cnt = $('[data-orl-count]', root);
      $$('select', root).forEach(function (sl) { sl.addEventListener('change', function () { sl.setCustomValidity(''); var w = sl.closest('.orl-select'); if (w) w.classList.remove('is-error'); }); });
      $$('input[type=text]', root).forEach(function (i) {
        i.addEventListener('input', function () {
          if (root.hasAttribute('data-orl-engrave')) i.value = i.value.toUpperCase();
          var fc = (i.closest('.orl-field') && $('[data-orl-count]', i.closest('.orl-field'))) || cnt;
          if (fc) fc.textContent = i.value.length + '/' + (i.maxLength > 0 ? i.maxLength : 18);
          i.setCustomValidity(''); i.closest('.orl-field') && i.closest('.orl-field').classList.remove('is-error');
        });
      });
      function sync() {
        var r = $('input[type=radio]:checked', root); if (!r) return;
        var c = parseInt(r.value, 10) || 1;
        $$('[data-orl-field]', root).forEach(function (f) {
          var n = parseInt(f.getAttribute('data-orl-field'), 10), i = $('input', f), on = n <= c;
          f.hidden = !on; i.disabled = !on; i.required = on;
        });
      }
      root.addEventListener('change', sync); sync();
      var any = $('input[form]', root), fid = any && any.getAttribute('form');
      document.addEventListener('submit', function (e) {
        if (!e.target || !fid || e.target.getAttribute('id') !== fid) return;
        var bad = null;
        $$('input[type=text]:not(:disabled), select:not(:disabled)', root).forEach(function (i) { if (i.tagName === 'INPUT') i.value = i.value.trim(); if (!bad && i.required && !i.value) bad = i; });
        if (bad) {
          e.preventDefault(); e.stopImmediatePropagation();
          bad.setCustomValidity(bad.getAttribute('data-orl-msg') || 'Please enter a name.');
          var f = bad.closest('.orl-field, .orl-select'); if (f) f.classList.add('is-error');
          bad.reportValidity(); bad.focus();
          setTimeout(function () { bad.setCustomValidity(''); }, 0);
        }
      }, true);
    });
  }

  /* ---------- product page live preview ---------- */
  function currentFinish(scope) {
    var checked = $$('input[type=radio]:checked', scope).map(function (i) { return i.value; });
    for (var k = 0; k < checked.length; k++) if (FIN.indexOf(normFin(checked[k])) > -1) return normFin(checked[k]);
    var sel = $$('select', scope).map(function (s) { return s.value; });
    for (var j = 0; j < sel.length; j++) if (FIN.indexOf(normFin(sel[j])) > -1) return normFin(sel[j]);
    return 'Gold';
  }
  function chooseFinish(scope, finish) {
    finish = normFin(finish);
    if (FIN.indexOf(finish) < 0) return;
    var r = $$('input[type=radio]', scope).filter(function (i) { return normFin(i.value) === finish; })[0];
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function initLive() {
    $$('[data-orl-live]').forEach(function (live, li) {
      var block = live.closest('[data-orl-name],[data-orl-engrave]'); if (!block) return;
      var section = block.closest('section, .product, product-info') || document;
      var mode = live.getAttribute('data-orl-live');
      var params = new URLSearchParams(location.search);
      if (mode === 'script') {
        var input = $('input[type=text]', block), nm = $('.orl-live__name', live), chain = $('.orl-live__chain', live);
        if (params.get('name') && input && !input.value) { input.value = params.get('name').slice(0, 18); input.dispatchEvent(new Event('input', { bubbles: true })); }
        var draw = function () {
          live.setAttribute('data-finish', currentFinish(section));
          nm.textContent = (input && input.value.trim()) || live.getAttribute('data-ph') || 'Your name';
          fitText(nm, live, 66);
          requestAnimationFrame(function () { chainPath(chain, nm, live); });
        };
        input && input.addEventListener('input', draw);
        document.addEventListener('change', function () { setTimeout(draw, 30); });
        window.addEventListener('resize', draw);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
        draw();
      } else {
        live.innerHTML = heartSVG([], 'p' + li);
        var texts = $$('input[type=text]', block), radios = $$('input[type=radio]', block);
        if (params.get('names')) {
          var parts = params.get('names').split('|').filter(Boolean).slice(0, 4);
          var rr = radios.filter(function (r) { return r.value === String(parts.length); })[0];
          if (rr) { rr.checked = true; rr.dispatchEvent(new Event('change', { bubbles: true })); }
          texts.forEach(function (t, k) { if (parts[k]) t.value = parts[k].toUpperCase().slice(0, 10); });
        }
        var drawH = function () {
          live.setAttribute('data-finish', currentFinish(section));
          var ns = texts.filter(function (t) { return !t.disabled; }).map(function (t, k) { return t.value.trim() || ('NAME ' + (k + 1)); });
          placeBeads($('svg', live), ns);
        };
        block.addEventListener('input', drawH);
        document.addEventListener('change', function () { setTimeout(drawH, 30); });
        drawH();
      }
      var fin = params.get('finish'); if (fin) setTimeout(function () { chooseFinish(section, fin); }, 60);
    });
  }


  /* ---------- lazy autoplay videos ---------- */
  var vio = null;
  function vidVisible(v) { return v.offsetParent !== null || getComputedStyle(v).display !== 'none' && v.getClientRects().length > 0; }
  function vidStart(v) {
    if (!vidVisible(v)) return;
    if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); v.load(); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function initVideos(root) {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vids = $$('video[data-ox-v]', root || document).filter(function (v) { return !v._ox; });
    if (!vids.length) return;
    if (!vio && 'IntersectionObserver' in window) {
      vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target; if (e.isIntersecting) vidStart(v); else if (!v.paused) v.pause(); });
      }, { rootMargin: '250px 0px' });
    }
    vids.forEach(function (v) {
      v._ox = 1; v.muted = true;
      v.addEventListener('playing', function () { v.classList.add('is-on'); });
      if (vio) vio.observe(v); else vidStart(v);
      if (v.hasAttribute('data-eager')) vidStart(v);
    });
  }
  window.addEventListener('resize', function () { $$('video[data-ox-v]').forEach(function (v) { var r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight && v.paused) vidStart(v); }); });

  /* ---------- v4: hero slider ---------- */
  function initSlider(root) {
    $$self('[data-jw-slider]', root).forEach(function (h) {
      if (h._jw) return; h._jw = 1;
      var slides = $$('[data-jw-slide]', h), dots = $$('[data-jw-dot]', h);
      if (slides.length < 2) return;
      var ms = parseInt(h.getAttribute('data-interval'), 10) || 6000, cur = 0, t = null;
      h.style.setProperty('--jw-int', ms + 'ms');
      function go(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        dots.forEach(function (d, k) { d.classList.remove('is-active'); void d.offsetWidth; d.classList.toggle('is-active', k === cur); });
        $$('video[data-ox-v]', slides[cur]).forEach(function (v) { vidStart(v); });
        restart();
      }
      function restart() { clearTimeout(t); if (!h.classList.contains('is-paused')) t = setTimeout(function () { go(cur + 1); }, ms); }
      var p = $('[data-jw-prev]', h), n = $('[data-jw-next]', h);
      if (p) p.addEventListener('click', function () { go(cur - 1); });
      if (n) n.addEventListener('click', function () { go(cur + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      h.addEventListener('mouseenter', function () { h.classList.add('is-paused'); clearTimeout(t); });
      h.addEventListener('mouseleave', function () { h.classList.remove('is-paused'); restart(); });
      var x0 = null;
      h.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      h.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) go(cur + (dx < 0 ? 1 : -1)); x0 = null; });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(t); else restart(); });
      restart();
    });
  }
  /* ---------- v4: carousels + tabs ---------- */
  function initCarousels(root) {
    $$self('[data-jw-carousel]', root).forEach(function (c) {
      if (c._jw) return; c._jw = 1;
      var tr = $('[data-jw-track]', c); if (!tr) return;
      var step = function () { var it = Array.prototype.filter.call(tr.children, function (e) { return e.offsetParent !== null; })[0]; return it ? it.getBoundingClientRect().width + 20 : 300; };
      var p = $('[data-jw-prev]', c), n = $('[data-jw-next]', c);
      if (p) p.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
      var tabs = $$('[data-jw-tab]', c);
      function show(key) {
        tabs.forEach(function (b) { var on = b.getAttribute('data-jw-tab') === key; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        Array.prototype.forEach.call(tr.children, function (card) {
          var list = (card.getAttribute('data-jw-in') || '1').split(',').map(function (s) { return s.trim(); });
          var vis = list.indexOf(key) > -1;
          card.classList.toggle('is-hidden', !vis);
          if (vis) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); card.classList.add('is-in'); }
        });
        tr.scrollTo({ left: 0 });
      }
      tabs.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-jw-tab')); }); });
      if (tabs.length) show(tabs[0].getAttribute('data-jw-tab'));
    });
  }

  /* ---------- v4: make-it-yours build animation ---------- */
  function initBuild(root) {
    $$self('[data-jw-build]', root).forEach(function (b) {
      if (b._jw) return; b._jw = 1;
      var imgs = $$('.jw-build__img', b), dots = $$('.jw-build__fins i', b), steps = $$('[data-jw-step]', b);
      var finLbl = $('[data-jw-fin-label]', b), nameEl = $('[data-jw-names]', b);
      var fr = (document.documentElement.lang || '').slice(0, 2) === 'fr';
      var FL = { gold: fr ? 'Or' : 'Gold', rose: fr ? 'Or rose' : 'Rose gold', silver: fr ? 'Argent' : 'Silver' };
      var names = (b.getAttribute('data-names') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var i = 0, tick = 0, timer = null, typer = null;
      function swap(el, txt) { if (!el) return; el.classList.remove('is-swap'); void el.offsetWidth; el.textContent = txt; el.classList.add('is-swap'); }
      function type(txt) {
        if (!nameEl) return; clearInterval(typer); var k = 0; nameEl.textContent = '';
        typer = setInterval(function () { k++; nameEl.textContent = txt.slice(0, k); if (k >= txt.length) clearInterval(typer); }, 70);
      }
      function step() {
        tick++;
        var phase = tick % 3;
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k === phase); });
        if (phase === 0 && imgs.length) {
          i = (i + 1) % imgs.length;
          imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          swap(finLbl, FL[imgs[i].getAttribute('data-fin')] || '');
        }
        if (phase === 1 && names.length) type(names[(Math.floor(tick / 3)) % names.length]);
      }
      function start() { if (timer) return; b.classList.add('is-live'); if (names.length) setTimeout(function () { type(names[0]); }, 1300); timer = setInterval(step, 1900); }
      function stop() { clearInterval(timer); timer = null; }
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { b.classList.add('is-live'); if (nameEl && names[0]) nameEl.textContent = names[0]; return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) start(); else stop(); }); }, { threshold: 0.3 }).observe(b);
      } else start();
    });
  }

  function initBuilds(root) {
    $$self('[data-jw-builds]', root).forEach(function (b) {
      if (b._jw) return; b._jw = 1;
      var fr = (document.documentElement.lang || '').slice(0, 2) === 'fr';
      var FL = { gold: fr ? 'Or' : 'Gold', rose: fr ? 'Or rose' : 'Rose gold', silver: fr ? 'Argent' : 'Silver' };
      function list(el) { return (el.getAttribute('data-list') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
      function swap(el, txt) { el.classList.remove('is-swap'); void el.offsetWidth; el.textContent = txt; el.classList.add('is-swap'); }
      var cards = $$('[data-jw-card]', b).map(function (c, ci) {
        var st = $('.jw-build__stage', c), imgs = $$('.jw-build__img', c), dots = $$('.jw-build__fins i', c), steps = $$('[data-jw-step]', c), ems = $$('.jw-call em', c), ii = 0, typer = null;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === 0); });
        ems.forEach(function (em) { var m = em.getAttribute('data-mode'), l = list(em); if (m === 'finish') em.textContent = imgs[0] ? (FL[imgs[0].getAttribute('data-fin')] || '') : ''; else if (l.length) em.textContent = l[0]; });
        var engs = $$('.jw-eng', c);
        function srcOf(em) { var m = (em.parentNode.className || '').match(/jw-call--(\d)/); return m ? m[1] : ''; }
        function engrave(n, txt, now) {
          engs.forEach(function (e) {
            if (e.getAttribute('data-src') !== n) return;
            var parts = txt.split(/\s*[&·+]\s*/), t = parts[+e.getAttribute('data-part')] || '';
            var lim = e.classList.contains('jw-eng--bar') ? 7 : 7, base = e.classList.contains('jw-eng--bar') ? 3.1 : 6.6;
            function put() { e.textContent = t; e.style.setProperty('--fs', (t.length > lim ? base * lim / t.length : base) + 'cqw'); e.classList.remove('is-out'); }
            if (now) put(); else { e.classList.add('is-out'); setTimeout(put, 380); }
          });
        }
        function type(el, txt) { var k = 0; clearInterval(typer); el.textContent = ''; engrave(srcOf(el), txt); typer = setInterval(function () { k++; el.textContent = txt.slice(0, k); if (k >= txt.length) clearInterval(typer); }, 70); }
        ems.forEach(function (em) { var l = list(em); if (em.getAttribute('data-mode') === 'type' && l.length) engrave(srcOf(em), l[0], true); });
        return function (tick) {
          var phase = (tick + ci) % 3, round = Math.floor((tick + ci) / 3);
          steps.forEach(function (s, k) { s.classList.toggle('is-on', k === phase); });
          if (phase === 0 && imgs.length > 1) {
            ii = (ii + 1) % imgs.length;
            imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === ii); });
            dots.forEach(function (d, k) { d.classList.toggle('is-on', k === ii); });
            ems.forEach(function (em) { if (em.getAttribute('data-mode') === 'finish') swap(em, FL[imgs[ii].getAttribute('data-fin')] || ''); });
          }
          if (phase === 1) ems.forEach(function (em) { var l = list(em); if (em.getAttribute('data-mode') === 'type' && l.length > 1) type(em, l[round % l.length]); });
          if (phase === 2) ems.forEach(function (em) { var l = list(em); if (em.getAttribute('data-mode') === 'text' && l.length > 1) swap(em, l[round % l.length]); });
        };
      });
      var tick = 0, timer = null;
      function step() { tick++; cards.forEach(function (f) { f(tick); }); }
      function start() { if (timer) return; b.classList.add('is-live'); step(); timer = setInterval(step, 1900); }
      function stop() { clearInterval(timer); timer = null; }
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { b.classList.add('is-live'); return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) start(); else stop(); }); }, { threshold: 0.25 }).observe(b);
      } else start();
    });
  }

  function init() {
    $$('.oss').forEach(function (root) { initReveal(root); initHero(root); initBand(root); initWriter(root); initMoments(root); initRotator(root); initTiles(root); initTrack(root); initSlider(root); initCarousels(root); initBuild(root); initBuilds(root); });
    initPdpFields();
    initLive();
    initVideos(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.oss'); if (r) { initReveal(r); initHero(r); initBand(r); initWriter(r); initMoments(r); initRotator(r); initTiles(r); initTrack(r); initSlider(r); initCarousels(r); initBuild(r); initBuilds(r); initVideos(r); } });
})();
